// avstemming-payroll-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'ave.c.gross': 'Bruttolønn',
  'ave.c.net': 'Netto lønn',
  'ave.c.withholding': 'Forskuddstrekk',
  'ave.c.diff': 'Differanse',
  'ave.c.status': 'Status',
  'ave.c.bank': 'Bank',
  'ave.c.amelding': 'A-melding',
  'ave.c.run': 'Kjøring',
  'ave.c.employeeCount': 'Antall ansatte',
  'ave.c.openRun': 'Åpne kjøring',
  'ave.c.none': 'Ingen',
  'ave.c.seeRuns': 'Se lønnskjøringene',
  'ave.c.requestDocs': 'Be klienten om dokumentasjon',
  'ave.c.close': 'Lukk',
  'ave.c.alert': 'Varsel',
  'ave.c.assessment': 'Vurdering',
  'ave.c.openCount': '{count} åpne',
  'ave.c.ofCount': '{done} av {total}',
  'ave.c.yes': 'Ja',
  'ave.c.no': 'Nei',
  'ave.c.missing': 'Mangler',
  'ave.c.settled': 'Stemmer',
  'ave.c.employee': 'Ansatt',
  'ave.c.openAccount': 'Åpne konto',
  'ave.page.noAccount': 'Lønnsområdet har ingen avstemmingskonto å lagre vurderingen på.',
  'ave.page.theRun': 'kjøringen',
  'ave.page.secOverview': 'Oversikt',
  'ave.page.secRuns': 'Lønnskjøringer',
  'ave.page.runsPosted': '{posted}/{total} bokført',
  'ave.page.ameldingMissing': '{count} mangler',
  'ave.page.secBank': 'Bankutbetalinger',
  'ave.page.secTax': 'Skatt og arbeidsgiveravgift',
  'ave.page.openTerms': '{count} åpne terminer',
  'ave.page.settledUp': 'Gjort opp',
  'ave.page.secHoliday': 'Feriepenger og pensjon',
  'ave.page.secLines': 'Lønnslinjer',
  'ave.page.secDocs': 'Dokumentasjon',
  'ave.page.secControls': 'Kontroll og godkjenning',
  'ave.page.areaFallback': 'Lønn',
  'ave.page.hintUnassessed': '{count} lønnslinjer krever vurdering',
  'ave.page.title': 'Lønn — lønnssystem mot hovedbok, A-melding og bank',
  'ave.page.responsible': 'Ansvarlig {name}',
  'ave.page.intro': 'Lønnen avstemmes mot fire kilder, ikke én saldo. Sammenlikningen er lønnskjøringenes egne tall mot hovedbokens egne tall — avstemmingen beregner ikke lønn, arbeidsgiveravgift eller feriepenger på nytt.',
  'ave.page.restricted': 'Lønnsdata er begrenset. Avstemmingen viser ansattnavn og beløp — ikke fødselsnummer eller bankkontonummer. Den trenger dem ikke for å konkludere.',
  'ave.page.txTitle': 'Kontroll av ansatte og lønnslinjer',
  'ave.page.resetFilters': 'Nullstill filtre',
  'ave.page.activeFilter': 'Aktivt filter: {label}',
  'ave.page.lineCount': '{count} lønnslinjer',
  'ave.page.removeFilter': 'Fjern filter',
  'ave.page.thEmployment': 'Arbeidsforhold',
  'ave.page.thRun': 'Lønnskjøring',
  'ave.page.thChange': 'Endring',
  'ave.page.assess': 'Vurder',
  'ave.page.viewAssessment': 'Se vurdering',
  'ave.page.noMatch': 'Ingen lønnslinjer passer med filtrene.',
  'ave.page.noRuns': 'Ingen bokførte lønnskjøringer i denne perioden. Uten lønnsgrunnlag kan ikke lønnen avstemmes.',
  'ave.chk.derived.ameldingDiscrepancy': 'A-meldingsavvik er behandlet',
  'ave.chk.derived.missingPayments': 'Utbetalinger som mangler er undersøkt',
  'ave.chk.derived.duplicates': 'Mulige dobbeltutbetalinger er vurdert',
  'ave.chk.derived.negativeNet': 'Negativ nettolønn er vurdert',
  'ave.chk.derived.unusualChange': 'Unormale lønnsendringer er vurdert',
  'ave.chk.derived.benefits': 'Naturalytelser er kontrollert',
  'ave.chk.derived.leaver': 'Lønn til sluttede ansatte er forklart',
  'ave.chk.derived.taxCard': 'Ansatte uten skattekort er fulgt opp',
  'ave.chk.autoTitle': 'Automatiske kontroller',
  'ave.chk.autoHint': 'Kontrollene krysser ikke av noe i den faglige sjekklista. De forteller hva den som krysser av bør ha sett på.',
  'ave.chk.thCheck': 'Kontroll',
  'ave.chk.thResult': 'Resultat',
  'ave.chk.ran': 'Kjørt',
  'ave.chk.findings': '{count} funn',
  'ave.chk.noFindings': 'Ingen funn',
  'ave.chk.listTitle': 'Faglig sjekkliste',
  'ave.chk.noPoints': 'Ingen kontrollpunkter er definert for lønn i denne perioden. Sjekklista følger kontoene på området — legg til en lønnskonto for å få arbeidsprogrammet.',
  'ave.chk.readOnlySuffix': '(utførerens, skrivebeskyttet)',
  'ave.chk.scopeHint': 'Punktene gjelder hele lønnsområdet. En avkryssing lagres på alle lønnskontoene i perioden.',
  'ave.chk.groupItems': 'Poster som krever behandling',
  'ave.chk.handled': '{done} av {total} behandlet',
  'ave.chk.notRelevant': 'Ikke aktuelt denne perioden',
  'ave.chk.followsAssessments': 'Følger av vurderingene',
  'ave.chk.groupAssessments': 'Overordnede faglige vurderinger',
  'ave.chk.groupReady': 'Klarstilling',
  'ave.chk.performedBy': 'Utføres av {name}',
  'ave.chk.progress': '{done} av {total} kontrollpunkter fullført',
  'ave.chk.blk.linesOne': '{count} lønnslinje krever vurdering',
  'ave.chk.blk.linesMany': '{count} lønnslinjer krever vurdering',
  'ave.chk.blk.mainOne': '{count} kontrollområde stemmer ikke mellom kildene',
  'ave.chk.blk.mainMany': '{count} kontrollområder stemmer ikke mellom kildene',
  'ave.chk.blk.accountsOne': '{count} kontrollkonto stemmer ikke med grunnlaget',
  'ave.chk.blk.accountsMany': '{count} kontrollkontoer stemmer ikke med grunnlaget',
  'ave.chk.blk.amelding': '{count} lønnskjøringer er ikke registrert som meldt',
  'ave.chk.blk.bankOne': '{count} lønnskjøring er ikke registrert utbetalt',
  'ave.chk.blk.bankMany': '{count} lønnskjøringer er ikke registrert utbetalt',
  'ave.chk.blk.checklistOne': '{count} kontrollpunkt gjenstår',
  'ave.chk.blk.checklistMany': '{count} kontrollpunkter gjenstår',
  'ave.chk.conclTitle': 'Konklusjon og godkjenning',
  'ave.chk.conclLabel': 'Konklusjon',
  'ave.chk.conclPlaceholder': 'Hva viser gjennomgangen av lønnen for denne perioden?',
  'ave.chk.conclSavedAs': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'ave.chk.risk': 'Gjenstående risiko',
  'ave.chk.nothingLeft': 'Ingenting står igjen som hindrer at området sendes til kontroll.',
  'ave.chk.followUp': 'Oppfølging neste periode',
  'ave.chk.noFollowUp': 'Ingen vurderinger er merket for oppfølging neste periode.',
  'ave.chk.followedUp': 'Følges opp',
  'ave.chk.runGross': '{run} · {money} brutto',
  'ave.chk.measure': 'Tiltak: {measure}',
  'ave.chk.noMeasure': 'Ingen tiltak notert',
  'ave.chk.deadline': 'Frist {date}',
  'ave.chk.openAssessment': 'Åpne vurdering',
  'ave.chk.sendToReview': 'Send området til kontroll',
  'ave.chk.leftOne': 'Én ting står igjen før området kan sendes.',
  'ave.chk.leftMany': '{count} ting står igjen før området kan sendes.',
});
